import { formatTermMiles, formatUsd, type RatedProductWire } from 'shared';
import type { CartLine } from '@/lib/widget-types.js';

const integerFmt = new Intl.NumberFormat(undefined);

export function formatInteger(value: number): string {
  return integerFmt.format(value);
}

export interface TierSpecLabels {
  termMonthsLabel: string;
  coverageMilesLabel: string;
  deductibleLabel: string;
}

/** The three specs a tier is summarised by. Shared so the product card and the order
 *  summary can't render the same tier two different ways. */
export function tierSpecLabels(tier: RatedProductWire): TierSpecLabels {
  return {
    termMonthsLabel: `${tier.term_months} mo`,
    coverageMilesLabel: formatTermMiles(tier.term_miles),
    deductibleLabel: tier.deductible_amount === null ? '—' : formatUsd(tier.deductible_amount),
  };
}

/** A term is both limits — whichever runs out first — so it is never named by months alone. */
export function tierTermLabel(tier: RatedProductWire): string {
  const { termMonthsLabel, coverageMilesLabel } = tierSpecLabels(tier);
  return `${termMonthsLabel} · ${coverageMilesLabel}`;
}

/** How one product is paid for, in one line. Shared so every review surface agrees. */
export function paymentTermsLabel(line: CartLine): string {
  if (line.entry.payment.type !== 'finance') return 'Paid in full';
  const parts = [
    `Financed · ${line.entry.payment.durationMonths} mo`,
    `${formatUsd(line.downPayment ?? 0)} down`,
  ];
  if (line.monthly !== null) parts.push(`about ${formatUsd(line.monthly)}/mo`);
  return parts.join(' · ');
}
